"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _react = _interopRequireDefault(require("react"));
var _CustomOverlayLayoutWithoutFooter = _interopRequireDefault(require("./CustomOverlayLayoutWithoutFooter"));
var _ListPicker = _interopRequireDefault(require("../ListPicker"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MonthPickerOverlay = /*#__PURE__*/function (_React$Component) {
  function MonthPickerOverlay(props) {
    var _this;
    (0, _classCallCheck2.default)(this, MonthPickerOverlay);
    _this = _callSuper(this, MonthPickerOverlay);
    _this.months = [];
    _this.handleMonthClick = _this.handleMonthClick.bind(_this);
    _this.months = props.localeUtils ? props.localeUtils.getMonths(props.children.props.locale) : props.children.props.localeUtils.getMonths(props.children.props.locale);
    return _this;
  }
  (0, _inherits2.default)(MonthPickerOverlay, _React$Component);
  return (0, _createClass2.default)(MonthPickerOverlay, [{
    key: "handleMonthClick",
    value: function handleMonthClick(month) {
      var monthIndex = this.months.indexOf(month);
      if (monthIndex >= 0 && monthIndex < 12 && this.props.onChange) {
        var date = this.props.value ? new Date(this.props.value) : new Date();
        date.setMonth(monthIndex);
        this.props.onChange(date);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        value = _this$props.value,
        translations = _this$props.translations,
        props = (0, _objectWithoutProperties2.default)(_this$props, ["value", "translations"]);
      var now = new Date();
      var currentMonth = props.localeUtils ? props.localeUtils.getMonths(props.children.props.locale)[now.getMonth()] : props.children.props.localeUtils.getMonths(props.children.props.locale)[now.getMonth()];
      return /*#__PURE__*/_react.default.createElement(_CustomOverlayLayoutWithoutFooter.default, (0, _extends2.default)({
        headerElement: translations.month
      }, props), /*#__PURE__*/_react.default.createElement(_ListPicker.default, {
        itemList: this.months,
        onItemClick: this.handleMonthClick,
        selectedItem: currentMonth,
        type: "month"
      }));
    }
  }]);
}(_react.default.Component);
MonthPickerOverlay.defaultProps = {
  translations: {
    month: 'Month'
  }
};
var _default = exports.default = MonthPickerOverlay;